import { ActionType, RESET_STORE } from "./types"

export const setLocation = (data: string) => {
  return {
    type: ActionType.SET_LOCATION,
    payload: data
  }
}

export const setPath = (data: string) => {
  return {
    type: ActionType.SET_PATH,
    payload: data
  }
}

export const setFacilityCode = (data: string) => {
  return {
    type: ActionType.SET_FACILITY_CODE,
    payload: data
  }
}

export const enableAppBarResult = (data: boolean) => {
  return {
    type: ActionType.ENABLE_APP_BAR,
    payload: data
  }
}

export const resetStore = () => {
  return {
    type: RESET_STORE
  }
}
